import React, { useState } from 'react';

const message = [
    'Learn React *',
    'Apply for Jobs#',
    'Yay! I got a job',
    'Invest your new Income!',
    'Started the Investing journey'
]

export default function Steps() {
    const [step, setStep] = useState(1);
    const [isOpen, setIsOpen] = useState(true);

    function handlePrevious() {
        setStep((s) => s - 1);
        if (step === 1) {
            setStep(message.length);
        }
    }

    function handleNext() {
        setStep((s) => s + 1);
        if (step > message.length - 1) {
            setStep(1);
        }
    }

    return <>
        <button onClick={() => setIsOpen((isOpen) => !isOpen)} className='open-close-btn'>{isOpen ? 'Close' : 'Open'}</button>
        {isOpen && <div className='steps'>
            <div className='numbers'>
                {message.map((_, i) => (
                    <div className={step >= i + 1 ? 'active' : ''} key={i}>{i + 1}</div>
                ))}
            </div>
            <p className='message'>
                <StepMessage step={step}>
                    {message[step - 1]}
                </StepMessage>
            </p>
            <div className='buttons'>
                {step > 1 &&
                    <Button handleClick={handlePrevious}>👈 Previous</Button>
                }
                {step < message.length &&
                    <Button handleClick={handleNext}>Next 👉</Button>
                }
            </div>
        </div>
        }</>
}

function Button({ children, handleClick }) {
    return <button onClick={handleClick}>{children}</button>
}

function StepMessage({ step, children }) {
    return <><span className='stepper'>Step {step}:</span> {children}</>
}